import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env?.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY;

console.log('🔍 SUPABASE INITIALIZATION:', {
  url: supabaseUrl ? `${supabaseUrl?.substring(0, 30)}...` : 'MISSING',
  keyLength: supabaseAnonKey?.length || 0,
  keyPrefix: supabaseAnonKey ? supabaseAnonKey?.substring(0, 10) + '...' : 'MISSING'
});

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('❌ SUPABASE CONFIG ERROR: Missing environment variables');
  console.error('URL:', supabaseUrl ? 'SET' : 'MISSING');
  console.error('Key:', supabaseAnonKey ? 'SET' : 'MISSING');
  throw new Error('Missing Supabase environment variables. Please check your .env file.');
}

// Add validation for URL format
try {
  const url = new URL(supabaseUrl);
  console.log('✅ SUPABASE URL VALID:', url?.hostname);
} catch (error) {
  console.error('❌ INVALID SUPABASE URL:', supabaseUrl);
  throw new Error('Invalid Supabase URL format. Please check your .env file.');
}

// Create client with additional options for better error handling
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  },
  global: {
    headers: {
      'x-client-info': 'business-transparency-platform',
    },
  },
  // Add retry logic for failed requests
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
});

console.log('✅ SUPABASE CLIENT CREATED');

// Test connection on initialization with detailed diagnostics
supabase?.from('user_profiles')?.select('count', { count: 'exact', head: true })?.then(({ data, error, count }) => {
  if (error) {
    console.error('❌ SUPABASE CONNECTION TEST FAILED:', {
      message: error?.message,
      code: error?.code,
      details: error?.toString(),
      hint: error?.hint || '',
      diagnosis: 'POSSIBLE CAUSES:\n'+ '1. Supabase project is PAUSED (check dashboard: https://supabase.com/dashboard)\n' +
        '2. Invalid ANON_KEY (regenerate in Settings → API)\n'+ '3. CORS not configured (add this domain to allowed origins)\n'+ '4. Network/firewall blocking requests\n'+ '5. Project deleted or moved'
    });
  } else {
    console.log('✅ SUPABASE CONNECTION SUCCESSFUL - Profiles count:', count);
  }
})?.catch(err => {
  console.error('❌ SUPABASE CONNECTION TEST EXCEPTION:', {
    message: err?.message,
    type: err?.constructor?.name,
    stack: err?.stack
  });
});

export default supabase;